import { Actor, Circle, CollisionType, Color, Engine, Scene, ScreenElement, vec } from "excalibur";
import { Resources } from "../../resources";
import { collision_groups } from "../../scenes/level-one/collision_groups";
import { LevelOne } from "../../scenes/level-one/level-one";
import { Tower } from "../towers/tower";
import { BottomBar } from "./bottom_bar";
import { DescriptionBox } from "./description_box";
import { DiceDisplay } from "./dice_display";
import { TopLeftBar } from "./top_left_bar";
import { TowerButton } from "./tower_button";
import { TowerButtons } from "./tower_buttons";
import { TowerCursor } from "./tower_cursor";
import { TowerSpec } from "./tower_specs";

export class Hud extends ScreenElement {
    public cursorOccupied = false;

    public bottomBar: BottomBar;
    public topLeftBar: TopLeftBar;

    constructor(private level: LevelOne) {
        super({
            width: level.engine.drawWidth,
            height: level.engine.drawHeight,
            z: 8347
        });
    }
    
    onInitialize() {
        const bottomBarHeight = this.height / 4;

        this.bottomBar = new BottomBar(this.level, bottomBarHeight);
        this.addChild(this.bottomBar);

        this.topLeftBar = new TopLeftBar(this.level);
        this.addChild(this.topLeftBar);

        const diceDisplayWidth = 100;
        const diceDisplayHeight = diceDisplayWidth * 4;
    }
}